<div
  class="phone-field-root w-100"
  [class.focused]="focused"
  [class.has-value]="hasValue"
  [class.error]="innerControl.invalid"
>
  <div class="mdc-text-field--filled">
    <mat-label class="input-placeholder">{{ placeholder + (required ? ' *' : '') }}</mat-label>
    <intl-tel-input
      #intlTelInput
      [formControl]="innerControl"
      [allowDropdown]="false"
      [separateDialCode]="separateDialCode"
      [strictMode]="strictMode"
      [inputAttributes]="{ id: id }"
      (focus)="onFocusIn()"
      (blur)="onFocusOut()"
      countryNameLocale="fr"
      [class.disabled]="innerControl.disabled"
      [class.error]="innerControl.invalid && innerControl.touched"
      [required]="required"
      [usePreciseValidation]="true"
      [loadUtils]="loadUtils"
    ></intl-tel-input>
  </div>

  @if (!innerControl.pristine) {
    @if (innerControl.hasError('required')) {
      <div class="phone-error">Le téléphone est obligatoire.</div>
    }
    @if (errorMessage) {
      <div class="phone-error">{{ errorMessage }}</div>
    }
  }
</div>
